module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/love-fc3586aa9382058bb68d3ff5b83ee0e8.svg";